<template>
  <div class="mb-8">
    <TModalHeading kind="green" class="mb-8">
      <template #title>
        {{ t('views.cottage-contact.form.success.title') }}
      </template>

      <template #body>
        {{ t('views.cottage-contact.form.success.subtitle') }}
      </template>
    </TModalHeading>

    <CottageContactRecommended :id="id" class="mb-6" />

    <div class="text-center">
      <UButton
        :ui="mobileFullWidthButton"
        variant="solid"
        size="lg"
        :label="t('views.cottage-contact.form.success.continue')"
        class="mt-2"
        @click="goBack()"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

const goBack = () => {
  window.history.back()
}

defineProps({
  id: { type: String, required: true },
})
</script>
